import {useEffect} from "react";

const useClickOutside = (targetSelector, onClickOutside = () => {}, initDependencies = []) => {
  const clickedOutside = (target, selector) => {
    return !target.closest(selector);
  };

  const onScreenClick = (event) => {
    if (clickedOutside(event.target, targetSelector)) onClickOutside();
  };

  useEffect(() => {
    requestAnimationFrame(() => {
      document.body.removeEventListener("click", onScreenClick);
      document.body.addEventListener("click", onScreenClick);
    });

    return () => {
      document.body.removeEventListener("click", onScreenClick);
    };
  }, initDependencies);
};

export default useClickOutside;
